<template>
  <v-dialog persistent scrollable v-model="dialog" max-width="500">
    <v-card>
      <v-card-title class="headline">
        Clone task: "{{ task.name }}"
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="formRef">
          <v-row>
            <v-col>
              <v-text-field
                v-model="name"
                :counter="120"
                :rules="nameRules"
                label="Task name*"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <PracticeSearch @onBusinessChanged="handleBusinessChange" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-list subheader>
                <v-row class="pl-7 align-center">
                  <v-checkbox
                    :value="isAllVersionsSelected"
                    @change="handleSelectAll"
                  />
                  <v-subheader class="headline pl-6">Versions:</v-subheader>
                </v-row>
                <v-list-item-group
                  multiple
                  class="overflow-y-auto versions-list"
                  v-model="selectedVersions"
                >
                  <template v-for="(version, index) in versions">
                    <v-list-item :key="version.id" :value="version.id">
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox :input-value="active" />
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>
                            {{ formatDate(version.created_at) }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                    <v-divider
                      v-if="index < versions.length - 1"
                      :key="index"
                    />
                  </template>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="error" :disabled="loading" @click="handleClose">
          cancel
        </v-btn>
        <v-btn text color="success" :loading="loading" @click="handleClone">
          Clone
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import PracticeSearch from '@/components/common/PracticeSearch';
import { DateTimeFormatter } from '@/shared/DateTime.formatter';
import { processingResultsApiV1, tasksApiV1 } from '@/api/v1';
import { processingResultsApiV2, tasksApiV2 } from '@/api/v2';

export default {
  data() {
    return {
      dialog: false,
      valid: true,
      task: {},
      name: '',
      selectedBusiness: {},
      selectedVersions: [],
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => (v && v.length <= 120) || 'Name must be less than 120 characters'
      ],
      versions: [],
      isAllVersionsSelected: false,
      loading: false
    };
  },
  components: {
    PracticeSearch
  },
  watch: {
    selectedVersions() {
      this.isAllVersionsSelected =
        this.versions.length &&
        this.selectedVersions.length === this.versions.length;
    }
  },
  methods: {
    open(task) {
      this.dialog = true;
      this.task = task;
      this.selectedBusiness = task.business;
      this.name = `${task.name} - clone ${DateTimeFormatter.formatDate(moment())}`;

      this.getTaskVersions(task.id);
    },
    handleBusinessChange(business) {
      this.selectedBusiness = business;
    },
    async getTaskVersions(taskId) {
      this.versions = await (
        this.$store.getters.isMatcherApiV2Enabled
          ? processingResultsApiV2
          : processingResultsApiV1
      ).fetchProcessingResultsForTask(taskId);

      this.selectedVersions = this.versions.map(({ id }) => id);
    },
    formatDate(dateString) {
      return moment(dateString).format('MM.DD.YYYY-HH:mm');
    },
    handleSelectAll() {
      if (this.isAllVersionsSelected) {
        this.selectedVersions = [];
      } else {
        this.selectedVersions = this.versions.map(({ id }) => id);
      }
    },
    handleClose() {
      this.dialog = false;
    },
    handleClone() {
      if (this.$refs.formRef.validate()) {
        this.loading = true;

        return (
          this.$store.getters.getFeatureToggleByNameEnabled('matcher_api_v2')
            ? tasksApiV2
            : tasksApiV1
        )
          .deepCloneTask({
            taskId: this.task.id,
            name: this.name,
            selectedBusiness: this.selectedBusiness,
            selectedVersions: this.selectedVersions
          })
          .then(() => {
            this.$refs.formRef.reset();
            this.loading = false;
            this.dialog = false;
          });
      }
    }
  }
};
</script>

<style lang="scss">
.versions-list {
  max-height: 375px;
}
</style>
